import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { branchUrls } from "../../URL/ApplicationUrls";
import { MdmApiError } from "../../Errors/MdmApiError";
import { addSuccessMessage } from "../../Messages/successMessages";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { Branch } from "../Branch";

export const useAddBranch = () => {
  return useMutation({
    mutationFn: (branch: Branch) =>
      axios.post<Branch>(branchUrls.branchesForCarrierWithId(branch.CarrierId), branch),
    onSuccess: async (response: AxiosResponse<Branch>) => {
      toast.success(addSuccessMessage(response.data.Id, "Branch"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
